import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMInputText, IMSelect } from '@insurancemenu/imenu-components-lib';
import SectionTitle from 'components/common/general/SectionTitle';
import { DefaultProposalFormDelegate } from 'store/modules/initiate-proposal/default/proposalFormDelegate';
import {
  IMFormStyled,
  FollowingSectionTitleStyled,
  IMZipCodeFieldStyled,
  IMZipCountyFieldStyled,
  IMZipStateFieldStyled,
} from '../styles';
import { DEFAULT_INITIATE_PROPOSAL_FORM_ID } from '../constants';
import DomainProductLines from '../DomainProductLines';

interface Props {
  proposalFormDelegate: DefaultProposalFormDelegate;
}

const DefaultInitiateProposalForm: React.FC<Props> = observer(({ proposalFormDelegate }) => {
  const { proposalForm, effectiveDatesOptions, domainProductLineItems, isAvailableProductLinesLoading } =
    proposalFormDelegate;

  return (
    <IMFormStyled id={DEFAULT_INITIATE_PROPOSAL_FORM_ID} formController={proposalForm}>
      <SectionTitle text="Basic Information" />
      <IMInputText label="Proposal Name" name="proposalName" size="full" />
      <IMSelect label="Effective Date" name="effectiveDate" size="full" options={effectiveDatesOptions} />
      <IMZipCodeFieldStyled size="s" />
      <IMZipStateFieldStyled size="s" />
      <IMZipCountyFieldStyled size="s" />

      <FollowingSectionTitleStyled text="Available Product Lines" />
      <DomainProductLines domainProductLineItems={domainProductLineItems} isLoading={isAvailableProductLinesLoading} />
    </IMFormStyled>
  );
});

export default DefaultInitiateProposalForm;
